var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStatusOk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "System_symbol_ok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sample",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-org-dashboard-0",
    transform: "translate(-1265.000000, -533.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(293.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(519.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(20.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(216.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(19.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System_symbol_ok",
    transform: "translate(198.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C4.04299731,0 0,4.04312365 0,8.99971875 C0,13.9568763 4.04299731,18 9,18 C13.9570027,18 18,13.9568763 18,8.99971875 C18,4.04312365 13.9570027,0 9,0 Z",
    id: "Path",
    fill: "#47C222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1748778,7.49034619 L8.36948737,12.1095524 C8.1550359,12.3161328 7.8710973,12.42 7.58895585,12.42 C7.30681442,12.42 7.02287584,12.3161328 6.80842435,12.1095524 L4.82564675,10.2035888 C4.39195157,9.7875429 4.39195157,9.112983 4.8226516,8.69693707 C5.25335164,8.27973705 5.95600971,8.27973705 6.38670971,8.69405182 L7.58895585,9.84986325 L11.6138148,5.98080915 C12.0445147,5.56591732 12.7465738,5.56591732 13.1772739,5.98369438 C13.6079739,6.3997403 13.6079739,7.07372319 13.1748778,7.49034619 Z",
    id: "path-3",
    fill: "#FFFFFF"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatusOk);
export default __webpack_public_path__ + "static/media/ic-status-ok.40a255f22ee3cb93e53d509754fb10b6.svg";
export { ForwardRef as ReactComponent };